module.exports = __webpack_public_path__ + "static/media/stock-inventory.edb8c4f3.svg";